const styles = {
  paddingX: "sm:px-16 px-6",
  paddingY: "sm:py-16 py-6",
  padding: "sm:px-16 px-6 sm:py-16 py-10",

  heroHeadText:
    "font-black text-white lg:text-[60px] sm:text-[40px] xs:text-[30px] text-[20px] lg:leading-[98px] mt-2",
  heroSubText:
    "text-[#dfd9ff] font-medium lg:text-[22px] sm:text-[20px] xs:text-[16px] text-[12px] lg:leading-[40px]",

  sectionHeadText:
    "text-white font-black md:text-[50px] sm:text-[40px] xs:text-[30px] text-[20px]",
  sectionSubText:
    "sm:text-[14px] text-[12px] text-secondary uppercase tracking-wider",
};

export { styles };
